import { ViewObjectContainerSaveableSettingsProvider } from "./view-object-container-saveable-settings-provider";

export class CanvasSaveableSettingsProvider extends ViewObjectContainerSaveableSettingsProvider {
  constructor(viewObjectProviders) {
    super(viewObjectProviders);
  }

  createSaveableSettings(settings) {
    if (settings.items === undefined) {
      return {
        items: []
      };
    }
    const parsedItems = [];
    for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
      const itemSettings = this.createItemSettings(settings.items[itemIndex]);
      parsedItems.push(itemSettings);
    }
    return {
      items: parsedItems
    };
  }

  applySaveableSettings(settings, saveableSettings) {
    if (settings.items === undefined || saveableSettings.items === undefined || settings.items.length != saveableSettings.items.length) {
      return;
    }
    for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
      this.applyItemSettings(settings.items[itemIndex], saveableSettings.items[itemIndex]);
    }
  }
}
